module.exports = __webpack_public_path__ + "static/img/type2.02ab0e7.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sportsBetting/type2.webp
// module id = qIRJ
// module chunks = 0